"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getPortalName = exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _portal = require("../portal");
var _excluded = ["name"];
var PORTAL_NAME = 'zeus/overlay';
var getPortalName = exports.getPortalName = function getPortalName(name) {
  return name != null ? PORTAL_NAME + "/" + name : PORTAL_NAME;
};
var OverlayDestination = function OverlayDestination(_ref) {
  var name = _ref.name,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_portal.PortalDest, Object.assign({
    name: getPortalName(name)
  }, rest));
};
OverlayDestination.defaultProps = {
  name: null
};
var _default = exports.default = OverlayDestination;